<template>
    <div v-if="store">
        <b-card>
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="6" lg="4">
                        <app-form-text-input label="Latitud" 
                            id="latitude" 
                            v-model="latitude">
                        </app-form-text-input>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <app-form-text-input label="longitud" 
                            id="longitude" 
                            v-model="longitude">
                        </app-form-text-input>
                    </b-col>
                    <b-col cols="12" md="5" lg="2" offset-lg="8">
                        <b-btn class="btn-block-xs-only" variant="primary" @click="getLocation"><i class="fa fa-map-marker" aria-hidden="true"></i> Obtener ubicación actual</b-btn>
                    </b-col>
                    <b-col cols="12" md="2" lg="2">
                        <b-btn class="btn-block-xs-only" variant="confirm" @click="saveLocation"><i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar ubicación</b-btn>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import storeRepository from '../../../../repositories/stores.repository.js';
import {mapGetters, mapMutations} from 'vuex';
import * as mutations from '../../../../store/commitTypes';
export default {
    props: {
        store: {
            required: true
        }
    },
    watch: {
        store(val){
            this.fillForm();
        }
    },
    data(){
        return {
            latitude: '',
            longitude: ''
        }
    },
    computed: {
        ...mapGetters(['selectedStore'])
    },
    methods: {
        ...mapMutations({
            setSelectedStore: mutations.SET_SELECTED_STORE
        }),
        getLocation(){
            if(navigator.geolocation){
                navigator.geolocation.getCurrentPosition(position => {
                    this.latitude = position.coords.latitude + '';
                    this.longitude = position.coords.longitude + '';
                })
            }
        },
        fillForm(){
            this.longitude = this.store.longitude;
            this.latitude = this.store.latitude;
        },
        saveLocation(){
            const formData = new FormData();

            formData.append('storeId', this.store.id);
            formData.append('longitude', this.longitude);
            formData.append('latitude', this.latitude);

            const sr = { ...storeRepository};

            sr.saveLocation(formData)
            .then(({data}) => {
                if(data.status){
                    this.setSelectedStore(data.store);
                    toastr.success(data.msg);
                }else{
                    toastr.error(data.msg);
                }
            })
            .catch(error => {
                toastr.error('Error al guardar la ubicación');
            });
        }
    },
    created(){
        this.fillForm();
    }
}
</script>

